export const DEFAULT_WHEEL_DIAMETER = 1016;